<template>
  <div id="deviceManage">
    <div class="device-quest">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        size="small"
      >
        <el-form-item label="时间：">
          <template v-if="form.timeType === 'day'">
            <el-date-picker
              v-model="form.dataRange"
              style="width: 240px"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </template>
          <template v-else-if="form.timeType === 'month'">
            <el-date-picker
              v-model="form.dataRange"
              type="monthrange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            ></el-date-picker>
          </template>
          <template v-else-if="form.timeType === 'year'">
            <el-date-picker
              v-model="form.dataRange[0]"
              type="year"
              align="right"
              placeholder="开始年份"
            />
            至
            <el-date-picker
              v-model="form.dataRange[1]"
              type="year"
              align="right"
              placeholder="结束年份"
            />
          </template>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSearch">查询</el-button>
          <el-button
            type="primary"
            @click="onReset"
            style="background-color: #3e7878; border-color: #3e7878"
          >重置</el-button>
          <el-button v-show="checkUserAuth(4, 257)" @click="onExportBtn">导出</el-button>
        </el-form-item>
      </el-form>
      <el-tabs v-model="form.timeType" @tab-click="onReset">
        <el-tab-pane label="日报表" name="day"></el-tab-pane>
        <el-tab-pane label="月度报表" name="month"></el-tab-pane>
        <el-tab-pane label="年度报表" name="year"></el-tab-pane>
      </el-tabs>
    </div>
    <el-row class="table-container">
      <div id="deviceTop" class="deviceManage-box">
        <p class="deviceManage-title">{{ titleList[form.timeType] }}表</p>
        <el-table
          :data="tableData"
          v-loading.body="tableLoading"
          border
          stripe
          show-summary
          :height="tableViewHeight"
          style="width: 100%"
          empty-text="暂无数据..."
          :span-method="cellMerge"
          :summary-method="getSummary"
        >
          <el-table-column
            prop="statDate"
            :label="
              form.timeType === 'day'
                ? '日期'
                : form.timeType === 'month'
                ? '月份'
                : '年份'"
            align="center"
            width="130"
          />
          <el-table-column prop="areaName" label="区域名称" align="center"/>
          <el-table-column prop="brandName" label="品牌名称" align="center"/>
          <el-table-column prop="brandBikeNum" label="车辆数" align="center"/>
          <el-table-column prop="orderNum" label="订单数" align="center"/>
          <el-table-column prop="turnoverRate" label="车辆周转率" align="center">
            <template v-slot="scope">
              <span :style="{ color: scope.row.turnoverRate > 1 ? 'green' : scope.row.turnoverRate < 0.5 ? 'red' : 'black' }">
                {{ Number(scope.row.turnoverRate) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
import { lookPDF } from '@/utils/tools'

export default {
  name: 'operationalReport',
  computed: {
    ...mapGetters([
      'user',
      'selfAreaId',
      'userBikeType'])
  },
  data() {
    return {
      titleList: {
        day: '日报运营',
        month: '月度运营',
        year: '年度运营'
      },
      tableData: [],
      total: 0,
      form: {
        timeType: 'day',
        dataRange: [this.dayjs(new Date().setDate(new Date().getDate() - 1)).format('YYYY-MM-DD'),
          this.dayjs(new Date().setDate(new Date().getDate() - 1)).format('YYYY-MM-DD')]
      },
      tableViewHeight: 50,
      deviceData: {},
      tableLoading: true,
      mergeConfig: [] // 合并配置
    }
  },
  created() {
    this.onSearch()
  },
  methods: {
    getQueryParams() {
      const params = {
        selfAreaId: this.selfAreaId,
        bikeType: this.userBikeType,
        timeType: this.form.timeType
      }
      // 按时间类型处理起止时间
      switch (this.form.timeType) {
        case 'day':
          params.startTime = this.dayjs(this.form.dataRange[0]).format('YYYY-MM-DD')
          params.endTime = this.dayjs(this.form.dataRange[1]).format('YYYY-MM-DD')
          break
        case 'month':
          params.startTime = this.dayjs(this.form.dataRange[0]).format('YYYY-MM')
          params.endTime = this.dayjs(this.form.dataRange[1]).format('YYYY-MM')
          break
        case 'year':
          // 年份校验（导出时也需要校验，所以抽离到这里）
          if (Number(this.form.dataRange[1]) < Number(this.form.dataRange[0])) {
            this.$message.error('结束年份小于开始年份')
            return null // 校验失败返回null，外部判断是否继续
          }
          params.startTime = this.dayjs(this.form.dataRange[0]).format('YYYY')
          params.endTime = this.dayjs(this.form.dataRange[1]).format('YYYY')
          break
      }
      return params
    },
    onSearch() {
      this.tableLoading = true
      const params = this.getQueryParams()
      if (!params) {
        this.tableLoading = false
        return
      }
      Api.getBrandOrderOperationalReport(params).then((res) => {
        this.tableLoading = false
        if (res.code === 200 && res.data) {
          this.tableData = res.data
          this.total = res.data.length
          this.computeMergeConfig() // 调用合并
        } else {
          this.$message.warning(res.message)
        }
        this.calcView()
      })
    },
    // 计算需要合并的行列
    computeMergeConfig() {
      // 空数据时直接返回空配置，避免后续循环报错
      if (!this.tableData.length) {
        this.mergeConfig = []
        return
      }
      // 定义各列的合并规则：key=列prop，value=合并依据的字段数组
      const mergeRules = {
        statDate: ['statDate'], // 时间列：仅按自身字段合并
        areaName: ['statDate', 'areaName'] // 区域列：按时间+区域合并
      }
      // 按规则计算每列的合并数组
      const statDateMergeArr = this.calculateMergeArr(mergeRules.statDate)
      const areaNameMergeArr = this.calculateMergeArr(mergeRules.areaName)
      // 组装最终的合并配置（和原逻辑一致，但更简洁）
      this.mergeConfig = this.tableData.map((_, index) => ({
        statDate: {
          rowspan: statDateMergeArr[index] || 1,
          colspan: statDateMergeArr[index] ? 1 : 0
        },
        areaName: {
          rowspan: areaNameMergeArr[index] || 1,
          colspan: areaNameMergeArr[index] ? 1 : 0
        }
      }))
    },
    // 通用合并数组计算
    calculateMergeArr(mergeByProps) {
      const mergeArr = []
      let currentCount = 1 // 当前连续可合并的行数
      // 从第2行开始对比（索引1），和前一行比较
      for (let i = 1; i < this.tableData.length; i++) {
        const prevRow = this.tableData[i - 1]
        const currRow = this.tableData[i]
        // 判断：所有合并依据字段的值都相等，才可以合并
        const isSameGroup = mergeByProps.every(prop => prevRow[prop] === currRow[prop])
        if (isSameGroup) {
          currentCount++ // 相等则累加合并数
        } else {
          // 不相等则把当前累计数推入，然后重置计数
          mergeArr.push(...Array(currentCount).fill(0))
          mergeArr[mergeArr.length - currentCount] = currentCount // 首行设为合并数，其余为0
          currentCount = 1
        }
      }
      // 处理最后一组数据
      mergeArr.push(...Array(currentCount).fill(0))
      mergeArr[mergeArr.length - currentCount] = currentCount
      return mergeArr
    },
    // 表格合并函数（无需修改）
    cellMerge({ row, column, rowIndex, columnIndex }) {
      if (rowIndex >= this.tableData.length) return { rowspan: 1, colspan: 1 }
      if (columnIndex === 0) {
        return this.mergeConfig[rowIndex]?.statDate || { rowspan: 1, colspan: 1 }
      }
      if (columnIndex === 1) {
        return this.mergeConfig[rowIndex]?.areaName || { rowspan: 1, colspan: 1 }
      }
      return { rowspan: 1, colspan: 1 }
    },
    // 自定义合计行
    getSummary({ data }) {
      // 初始化合计数组
      const sums = ['合计', '', '', 0, 0, 0]
      // 计算总车辆数、总订单数
      let totalBike = 0
      let totalOrder = 0
      data.forEach(item => {
        totalBike += Number(item.brandBikeNum) || 0
        totalOrder += Number(item.orderNum) || 0
      })
      // 车辆周转率 = 总订单数 / 总车辆数
      sums[3] = totalBike // 车辆数列（第4列 index=3）
      sums[4] = totalOrder // 订单数列（第5列 index=4）
      // 计算周转率
      if (totalBike !== 0) {
        sums[5] = (totalOrder / totalBike).toFixed(2)
      } else {
        sums[5] = '0.00'
      }
      return sums
    },
    onReset() {
      this.form.dataRange = [this.dayjs(new Date().setDate(new Date().getDate() - 1)).format('YYYY-MM-DD'),
        this.dayjs(new Date().setDate(new Date().getDate() - 1)).format('YYYY-MM-DD')]
      if (this.form.timeType === 'year') {
        const time = this.dayjs().format('YYYY')
        this.form.dataRange = [time, time]
      }
      this.onSearch()
    },
    onExportBtn() {
      if (this.total > 0) {
        this.onSureExport()
      } else {
        this.$message({
          message: '导出数据为空，请核查！',
          type: 'warning'
        })
      }
    },
    onSureExport() {
      const params = this.getQueryParams()
      if (!params) return
      Api.exportBrandOperationalReport(params)
        .then(res => {
          if (res.code === 200) {
            lookPDF(res.data)
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // 56: 导航栏高度修正
        // 250: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 250
      })
    }
  }
}
</script>

<style scoped lang="less">
.device-quest {
  background: #fff;
  padding: 24px 16px 0;
  margin: 16px 20px 0;
  /deep/ .el-tabs__header {
    margin: 0 0 1px;
  }
}
.table-container {
  margin-top: 10px;
  .deviceManage {
    &-box {
      padding: 10px 16px;
      line-height: 30px;
    }
    &-title {
      font-size: 18px;
      line-height: 50px;
      font-weight: 600;
      text-align: center;
    }
  }
}
.tip {
  cursor: pointer;
  margin-left: 4px;
  vertical-align: middle;
}
/* 表头：加粗 + 浅灰背景 */
/deep/ .el-table thead th {
  background-color: #f5f7fa !important;
  font-weight: bold !important;
}
</style>
